export default "__VITE_ASSET__CznjfsRd__"